import { css } from 'styled-components';
import { convertCssNumberToString } from '../helpers/convertCssNumberToString.js';

const LIGHTBLUE = '#87D7FC';
const resetKeyboardFocus = css(["&:focus-visible{outline:none;box-shadow:none;border-radius:inherit;&::after{display:none;}}"]);
const keyboardFocusShadowStyles = ({
  radius = 4
} = {}) => css(["box-shadow:0 0 4px 4px ", ";border-radius:", ";"], LIGHTBLUE, convertCssNumberToString(radius));
const keyboardFocusShadow = ({
  hasReset,
  radius = 4,
  element
} = {}) => css(["", " &:focus ", "{outline:none;}&:focus-visible ", "{outline:none;", "}"], hasReset && resetKeyboardFocus, element || '', element || '', keyboardFocusShadowStyles({
  radius
}));
const afterFocusStyles = (offset = 0, radius) => css(["position:relative;&::after{content:'';position:absolute;inset:", "px ", "px ", "px ", "px;box-shadow:0 0 4px 4px ", ";border-radius:", ";}"], offset, offset, offset, offset, LIGHTBLUE, convertCssNumberToString(radius));
const keyboardFocusShadowAfter = ({
  hasReset,
  offset,
  radius = 4,
  element
} = {}) => css(["", " &:focus ", "{outline:none;}&:focus-visible ", "{outline:none;", "}"], hasReset && resetKeyboardFocus, element || '', element || '', afterFocusStyles(offset, radius));
const keyboardFocusOutline = ({
  hasReset,
  offset = 0,
  radius = 4,
  element
} = {}) => css(["", " &:focus ", "{outline:none;}&:focus-visible ", "{border-radius:", ";outline:2px solid ", ";outline-offset:", "px;}"], hasReset && resetKeyboardFocus, element || '', element || '', convertCssNumberToString(radius), LIGHTBLUE, offset);

export { afterFocusStyles, keyboardFocusOutline, keyboardFocusShadow, keyboardFocusShadowAfter, keyboardFocusShadowStyles, resetKeyboardFocus };
//# sourceMappingURL=keyboardFocus.js.map
